var styleDataHash = "ec5bdae3";
const injectCss = (() => {
  var css = `.NyLa4{max-height:580px;overflow:auto}.uFrGq{min-height:570px}`;
  var isTest = typeof process !== "undefined" && process.env && false;
  if (isTest || !css || typeof document === "undefined") {
    return;
  }
  if (document.querySelector('style[data-ricos-style-hash="' + styleDataHash + '"]')) {
    return;
  }
  var head = document.head || document.getElementsByTagName("head")[0];
  var style = document.createElement("style");
  style.setAttribute("data-ricos-style-hash", styleDataHash);
  style.type = "text/css";
  head.appendChild(style);
  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
});
injectCss();
var button_input_modal_default = {
  "content": "NyLa4",
  "modal": "uFrGq"
};
export {
  button_input_modal_default as default,
  injectCss
};
//# sourceMappingURL=button-input-modal-scss.js.map
